module.exports = __webpack_public_path__ + "fonts/raleway-regular-webfont.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Raleway/raleway-regular-webfont.woff2
// module id = 3452
// module chunks = 0